import { Box } from "@mui/material";
import { ParagraphText } from "../../../../../Libraries";
import moment from "moment";
import { formatNum } from "../../../../../oscar-pos-core/constants";
import { ImgPlaceHolder, RupinFavIcon } from "../../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import styles from "../../TransactionListing/TransactionListing.module.css";

const VoucherTransactionRow = ({ item, onRowClick }) => {
  const {
    created_at,
    bill_company,
    voucher_name,
    logo_link,
    consumer_number_masked,
    consumer_number,
    customer_name,
    customer_phone,
    amount,
    mode,
    service
  } = item || {};

  const isCashback = mode === "credit";
  const companyName = bill_company || service || "";
  const phone = consumer_number_masked || consumer_number || customer_phone || "";

  const detailParts = isCashback
    ? [voucher_name, customer_name, phone]
    : [customer_name, phone];
  const detailDisplay = detailParts.filter(Boolean).join(" • ") || "-";

  return (
    <Box
      id={`voucher_transaction_row_${item?.id}`}
      className={`invoiceListTableBody accountTableHeaderMain${!isCashback ? " pointer" : ""}`}
      onClick={
        !isCashback
          ? () => {
              triggerLogEvent(analytics, "w_voucher_txn_transaction_detail");
              onRowClick?.(item);
            }
          : undefined
      }
    >
      {/* Date */}
      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {created_at ? moment(created_at).format("DD MMM YYYY") : "-"}
        </ParagraphText>
      </Box>

      {/* Company — cashback always shows RUPIN, voucher payment shows company (+ voucher variant) */}
      <Box className={`invListTableHeaderCol fiveColumn textLeft ${styles.contactCell}`}>
        {isCashback ? (
          <Box className={styles.companyLogoFallback}>
            <RupinFavIcon width={20} height={20} />
          </Box>
        ) : logo_link ? (
          <img
            src={logo_link}
            alt={companyName}
            className={styles.companyLogo}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : (
          <Box className={styles.companyLogoFallback}>
            <ImgPlaceHolder width={20} height={20} />
          </Box>
        )}
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine newFontColor">
          {isCashback ? "RUPIN" : companyName}
          {!isCashback && voucher_name ? (
            <span className="newLightColor">&nbsp;({voucher_name})</span>
          ) : null}
        </ParagraphText>
      </Box>

      {/* Type */}
      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {isCashback ? "Cashback" : "Voucher"}
        </ParagraphText>
      </Box>

      {/* Contact / Details */}
      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newLightColor truncateOneLine">
          {detailDisplay}
        </ParagraphText>
      </Box>

      {/* Amount */}
      <Box className="invListTableHeaderCol fiveColumn textRight">
        <ParagraphText
          className={`fontSize14 fontWeight500 ${isCashback ? styles.creditAmount : styles.debitAmount}`}
        >
          {isCashback ? "+" : "-"}Rs. {formatNum(Math.abs(amount || 0))}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default VoucherTransactionRow;
